import React, { useState } from "react";
import { useProfile } from "@/_actions/userActions";
import EditProfile from "./forms/EditProfile";
import { Button } from "@/components/ui/button";
import { Phone, Mail, Edit, MessageSquare, Loader2 } from "lucide-react";

export default function UserProfile() {
  const { data: profile = {}, isLoading, mutate: profileMutate } = useProfile();
  const [showEditProfile, toggleEditProfile] = useState(false);

  return (
    <div>
      {isLoading ? (
        <div className="flex justify-center items-center py-4">
          <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
        </div>
      ) : profile && !showEditProfile ? (
        <div className="space-y-3">
          <div className="text-sm font-semibold uppercase tracking-wide text-blue-800">
            {profile && profile.first_name} {profile && profile.last_name}
          </div>

          <div className="flex items-center">
            <Phone className="h-4 w-4 text-gray-400" />
            <span className="ml-2 text-sm">
              {profile ? profile?.contact?.mobile : "------------"}
            </span>
          </div>

          <div className="flex items-center">
            <MessageSquare className="h-4 w-4 text-gray-400" />
            <span className="ml-2 text-sm">
              {profile ? profile?.contact?.whatsapp : "------------"}
            </span>
          </div>

          <div className="flex items-center">
            <Mail className="h-4 w-4 text-gray-400" />
            <span className="ml-2 text-sm">
              {profile ? profile.email : "------------"}
            </span>
          </div>

          <Button
            onClick={() => toggleEditProfile(true)}
            type="button"
            data-splitbee-event="account-edit-contact"
            size="sm"
            className="mt-1"
          >
            <span>Editar</span>
            <Edit className="ml-1 h-3 w-3" />
          </Button>
        </div>
      ) : null}

      {showEditProfile ? (
        <EditProfile
          data={profile}
          callBack={() => {
            toggleEditProfile(false);
            profileMutate();
          }}
        />
      ) : null}
    </div>
  );
}
